import DesignSpecifications from './DesignSpecifications';

export default DesignSpecifications;
